import { render, staticRenderFns } from "./CreateResourceDropdown.vue?vue&type=template&id=8da54450"
import script from "./CreateResourceDropdown.vue?vue&type=script&lang=js"
export * from "./CreateResourceDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports